import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import urls from '@src/@core/auth/jwt/urls'
import axios from 'axios'

const axiosInstance = axios.create({
    baseURL: urls.url,
    // timeout: 35000,
    headers: { Authorization: "Bearer " + localStorage.getItem("token"), "Content-Type": "application/json" }
})

export const getAllData = createAsyncThunk(
    'customerCards/getAllData',
    async (params, { rejectWithValue }) => {
        try {
            const response = await axiosInstance.get(
                `${urls.url}/integrations/datafast-cards/`,
                { params }
            )
            return response.data
        } catch (error) {
            return rejectWithValue(error.response?.data)
        }
    }
)

export const deleteCustomer = createAsyncThunk(
    'customerCards/deleteCustomer',
    async (id, {dispatch, rejectWithValue }) => {
        try {
            const response = await axiosInstance.delete(
                `${urls.url}/integrations/datafast-cards/${id}/anular/`
            )
            dispatch(getAllData({}))
            return response.data
        } catch (error) {
            return rejectWithValue(error.response?.data)
        }
    }
)

export const getRecurrentPayments = createAsyncThunk(
    'customerCards/get',
    async ({ id, params }) => {
        const res = await axiosInstance.get(`${urls.url}/integrations/datafast-cards/${id}/recurrent-payments/`, {
            params
        })
        return res.data
    }
)

export const deleteCustomerCard = createAsyncThunk('customerCards/deleteCustomerCard', async (params, { dispatch }) => {
  await axiosInstance.delete(`/integrations/datafast-cards/${params.id}/`)
  await dispatch(getAllData(params.getData))
  return params.id
})

const initialState = {
    allData: [],
    total: 0,
    isFetching: false,
    payments: [],           // listado de pagos recurrentes
    totalPayments: 0,       // total del backend
    loadingPayments: false, // loading específico
    errorPayments: null
}

const customerCardRecurrent = createSlice({
    name: 'customerCards',
    initialState,
    reducers: {
        setIsFetchingResults(state) {
            state.isFetching = true
        },
        clearErrorPayments(state) {
            state.errorPayments = null
        }
    },
    extraReducers: builder => {
        builder
            .addCase(getAllData.fulfilled, (state, action) => {
                state.allData = action.payload.results
                state.total = action.payload.count
                state.isFetching = false
            })
            .addCase(getAllData.rejected, state => {
                state.isFetching = false
            })
            .addCase(getRecurrentPayments.pending, (state) => {
                state.loadingPayments = true
                state.errorPayments = null
            })
            .addCase(getRecurrentPayments.fulfilled, (state, action) => {
                state.payments = action.payload.results
                state.totalPayments = action.payload.count
                state.loadingPayments = false
            })
            .addCase(getRecurrentPayments.rejected, (state, action) => {
                state.loadingPayments = false
                state.errorPayments = action.error.message
            })
    }
})

export const { setIsFetchingResults } = customerCardRecurrent.actions
export default customerCardRecurrent.reducer
